import React from 'react';
import Icon from '../../../components/AppIcon';

const DeadlineCalendar = ({ deadlines }) => {
  const getUrgencyStyle = (urgency) => {
    if (urgency === 'critical') return 'border-l-error bg-error-subtle ';
    if (urgency === 'high') return 'border-l-warning bg-warning-subtle/50';
    return 'border-l-success bg-success-subtle/50';
  };

  const getUrgencyBadge = (daysLeft) => {
    if (daysLeft < 0) return <span className="text-[11px] font-medium text-error bg-error-subtle px-1.5 py-0.5">Overdue</span>;
    if (daysLeft <= 3) return <span className="text-[11px] font-medium text-error bg-error-subtle px-1.5 py-0.5">{daysLeft}d</span>;
    if (daysLeft <= 7) return <span className="text-[11px] font-medium text-warning bg-warning-subtle px-1.5 py-0.5">{daysLeft}d</span>;
    return <span className="text-[11px] font-medium text-success bg-success-subtle px-1.5 py-0.5">{daysLeft}d</span>;
  };

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <div className="bg-card border border-border overflow-hidden">
      <div className="px-4 py-2.5 border-b border-border flex items-center justify-between">
        <h3 className="text-sm font-semibold text-foreground">Deadlines</h3>
        {deadlines?.length > 0 && (
          <span className="text-xs text-muted-foreground">{deadlines?.length}</span>
        )}
      </div>

      <div className="divide-y divide-border">
        {deadlines?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="CalendarCheck" size={20} className="text-muted-foreground mx-auto mb-1.5" />
            <p className="text-xs text-muted-foreground">No upcoming deadlines</p>
          </div>
        ) : (
          deadlines?.slice(0, 5)?.map((deadline) => (
            <div key={deadline?.id} className={`border-l-2 ${getUrgencyStyle(deadline?.urgency)} px-3 py-2.5`}>
              <div className="flex items-start justify-between gap-2 mb-0.5">
                <h4 className="text-xs font-medium text-foreground line-clamp-1 flex-1">{deadline?.title}</h4>
                {getUrgencyBadge(deadline?.daysLeft)}
              </div>
              <p className="text-[11px] text-muted-foreground">
                {deadline?.conference} &middot; {formatDate(deadline?.deadline)}
              </p>
            </div>
          ))
        )}
      </div>

      {deadlines?.length > 5 && (
        <div className="px-4 py-2 border-t border-border">
          <p className="text-[11px] text-center text-muted-foreground">+{deadlines?.length - 5} more</p>
        </div>
      )}
    </div>
  );
};

export default DeadlineCalendar;
